import React from 'react'
import styles from './FancyRule.module.css'

export default function FancyRule() {
  return <div className={styles.fancyRule}>• &nbsp;•&nbsp; •</div>
}
